import React from "react";
import { Link } from "react-router-dom";
import "./Testimonials.css";
import '@fortawesome/fontawesome-free/css/all.min.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: "E.T.",
      text: "Sandy helped me through one of the hardest times of my life with professionalism and compassion. I always felt supported.",
      rating: 5,
      service: "Divorce & Financial Settlement"
    },
    {
      name: "J.M.",
      text: "I couldn't have asked for a better solicitor. Sandy communicated every step clearly and fought for a fair settlement.",
      rating: 5,
      service: "Financial Settlement"
    },
    {
      name: "S.L.",
      text: "The guidance and support I received was exceptional. Sandy made a difficult process much more manageable.",
      rating: 5,
      service: "Child Arrangements"
    },
    {
      name: "A.P.",
      text: "Sandy's expertise in complex financial matters is outstanding. She secured an excellent outcome for my case.",
      rating: 5,
      service: "High Net Worth Financial Dispute"
    },
    {
      name: "M.K.",
      text: "Professional, empathetic, and always available when I needed guidance. Highly recommend Sandy's services.",
      rating: 5,
      service: "Divorce & Mediation"
    },
    {
      name: "R.D.",
      text: "Sandy understood my cultural background and provided sensitive, tailored advice. Truly exceptional service.",
      rating: 5,
      service: "International Divorce"
    },
    {
      name: "L.H.",
      text: "Clear communication throughout the entire process. Sandy kept me informed and made everything understandable.",
      rating: 5,
      service: "Pre-Nuptial Agreement"
    },
    {
      name: "C.W.",
      text: "The best decision I made was choosing Sandy. She fought for my children's best interests and achieved a great outcome.",
      rating: 5,
      service: "Child Arrangements & Residence"
    },
    {
      name: "T.B.",
      text: "Sandy's negotiation skills are excellent. She resolved my case without going to court, saving time and stress.",
      rating: 5,
      service: "Mediation & Settlement"
    }
  ];

  return (
    <div className="page-container">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1>Client Testimonials</h1>
          <p className="page-hero-subtitle">
            Don't just take our word for it — hear from those we've helped through their family law journey
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="page-content">
        <div className="page-wrapper">
          {/* Intro */}
          <div className="testimonials-intro">
            <h2>Trusted by Clients Across England</h2>
            <p>
              Our clients come from all walks of life — from professionals to families navigating difficult transitions. 
              What they all share is the need for expert legal guidance delivered with empathy and professionalism. 
              Here's what they have to say about working with us.
            </p>
          </div>

          {/* Stats */}
          <div className="testimonials-stats">
            <div className="stat-card">
              <div className="stat-number">15+</div>
              <div className="stat-label">Years of Experience</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">500+</div>
              <div className="stat-label">Cases Resolved</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">98%</div>
              <div className="stat-label">Client Satisfaction</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">5.0</div>
              <div className="stat-label">Average Rating</div>
            </div>
          </div>

          {/* Testimonials Grid */}
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div className="testimonial-card" key={index}>
                <div className="testimonial-rating">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="fa-solid fa-star star"></i>
                  ))}
                </div>
                <p className="testimonial-text">"{testimonial.text}"</p>
                <div className="testimonial-footer">
                  <div>
                    <span className="testimonial-name">— {testimonial.name}</span>
                    <span className="testimonial-service">{testimonial.service}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Why Clients Choose Us */}
          <div className="why-clients">
            <h2>Why Clients Choose Us</h2>
            <div className="why-grid">
              <div className="why-item">
                <h4><i className="fa-solid fa-trophy"></i> Results-Driven</h4>
                <p>We focus on achieving the best possible outcomes for our clients, whether through negotiation or court representation.</p>
              </div>
              <div className="why-item">
                <h4><i className="fa-solid fa-file-lines"></i> Clear Communication</h4>
                <p>We explain complex legal processes in plain English and keep you informed at every step.</p>
              </div>
              <div className="why-item">
                <h4><i className="fa-solid fa-heart"></i> Empathetic Support</h4>
                <p>We understand that family law matters are emotionally challenging and provide compassionate support throughout.</p>
              </div>
              <div className="why-item">
                <h4><i className="fa-solid fa-scale-balanced"></i> Expert Knowledge</h4>
                <p>Years of experience and specialized expertise in all areas of family and matrimonial law.</p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="page-cta">
            <h2>Ready to Experience Our Service?</h2>
            <p>Join our satisfied clients and book a free consultation today</p>
            <Link to="/contact" className="cta-button">
              Book a Consultation
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
